import * as Html from "../util/Html.ts";

import * as amplify from "../util/amplify.ts";
import ApiServer from "../ApiServer.js";
import { TaskCache } from "../server/objects/TaskBeans.ts";

export {init,destroy}
Html.registerWidget('widget/minilist',{init:init,destroy:destroy})

var node;
function display(){
  import("../widget/minilist.mustache").then(function(TPL){
    var cloned = [].concat(TaskCache.datas);
    cloned.sort(function(a,b){
      if(a.complete!==b.complete){
        return a.complete?1:-1;
      }
      return b.creationDate-a.creationDate;
    })
    Html.setHtml(node,TPL,{feed:cloned.slice(0,3)});
  });

}

function init(container){
  node = container;
  if(container.is(':visible')) {
    ApiServer.loadTaskAndList();
    amplify.subscribe("taskRefreshed",display);        
  }
}
function destroy(){
  amplify.unsubscribe("taskRefreshed",display);
}
